// How to obtain this data:
// https://www.notion.so/factorialco/Initial-Analysis-de489c4a42d443028b33e31c8ba371e3?pvs=4#f99925d39d2a49439b03a11139fbddc4

type TopModulesByIndustryType = {
  [key: string]: string[]
}

export const topModulesByIndustry: TopModulesByIndustryType = {
  aerospace_defense: ['timeoff', 'time_tracking', 'shift_management'],
  agriculture: ['timeoff', 'time_tracking', 'shift_management'],
  automobiles_components: ['timeoff', 'time_tracking', 'reviews'],
  banking_insurance: ['timeoff', 'time_tracking', 'reviews', 'ats', 'shift_management'],
  chemicals: ['timeoff', 'time_tracking'],
  commercial_services: ['timeoff', 'time_tracking', 'reviews', 'expenses'],
  commodities: ['timeoff', 'time_tracking'],
  construction_engineering: ['timeoff', 'time_tracking', 'reviews', 'expenses', 'ats'],
  consumer_durables_apparel: ['timeoff', 'time_tracking', 'shift_management', 'ats'],
  consumer_services: ['timeoff', 'time_tracking', 'shift_management', 'reviews', 'ats'],
  containers_packaging: ['timeoff', 'time_tracking'],
  diversified_financials: ['timeoff', 'time_tracking', 'reviews', 'ats'],
  education: ['timeoff', 'time_tracking', 'reviews', 'ats'],
  energy: ['timeoff', 'time_tracking', 'reviews', 'expenses', 'ats'],
  food_staples_retailing: ['timeoff', 'time_tracking', 'shift_management'],
  food_beverage_tobacco: ['timeoff', 'time_tracking', 'shift_management', 'reviews'],
  government_administration: ['timeoff', 'time_tracking', 'shift_management', 'reviews'],
  healt_care_equipment_services: ['timeoff', 'time_tracking', 'shift_management', 'reviews'],
  hospitality: ['timeoff', 'time_tracking', 'shift_management', 'reviews'],
  internet_direct_marketing_retails: ['timeoff', 'time_tracking'],
  legal_services: ['timeoff', 'time_tracking', 'reviews'],
  machinery: ['timeoff', 'time_tracking', 'expenses'],
  manufacturing: ['timeoff', 'time_tracking', 'shift_management'],
  media_entertainment: ['timeoff', 'time_tracking', 'shift_management'],
  metals_mining: ['timeoff', 'time_tracking'],
  military: ['timeoff', 'time_tracking'],
  other: ['timeoff', 'time_tracking', 'shift_management', 'reviews'],
  non_profit_org: ['timeoff', 'time_tracking', 'reviews'],
  pharmaceuticals_biotechnology: ['timeoff', 'time_tracking', 'reviews'],
  real_estate: ['timeoff', 'time_tracking', 'reviews'],
  research_consulting: ['timeoff', 'time_tracking', 'reviews', 'trainings'],
  retailing: ['timeoff', 'time_tracking', 'shift_management', 'reviews', 'expenses'],
  software_it_services: ['timeoff', 'time_tracking', 'reviews', 'expenses', 'ats'],
  tech_hardware_equipment: ['timeoff', 'time_tracking', 'reviews'],
  telecommunication: ['timeoff', 'time_tracking', 'payroll'],
  trading_distributors: ['timeoff', 'time_tracking'],
  transportation: ['timeoff', 'time_tracking', 'reviews', 'expenses', 'ats'],
  travel_tourism: ['timeoff', 'time_tracking', 'shift_management'],
  utilities: ['timeoff', 'time_tracking', 'shift_management'],
}
